import { IToastActionPayload, ToastType, ToastActionNames } from "shared-types/index"
import store from 'appRoot/Store';
import { rootDisplayActions } from 'app/reducers/display/slice';

/**
 * Purpose of these "Actions" is to mimic a more redux-style of event management, which
 * should make transitioning to redux a little easier when the time comes.
 */

const NS = 'ToastActions';
/**
 * @deprecated don't use this, use the class instead - ToastActionClean
 * @param $rootScope
 * @constructor
 */
export default function ToastActions($rootScope: any) {
  "ngInject";

  return {

    clearToast: (): void => {
      $rootScope.$broadcast(ToastActionNames.CLEAR_TOAST);
    },

    showToast: (msg: string, type: ToastType, hideDismissBtn = false, isImportant = false): void => {

      $rootScope.$broadcast(ToastActionNames.SHOW_TOAST, { payload: {msg, type, hideDismissBtn, isImportant} as IToastActionPayload });
    },

    showToastFullOptions: (props: IToastActionPayload): void => {
      $rootScope.$broadcast(ToastActionNames.SHOW_TOAST_FULL_OPTIONS, { payload: props as IToastActionPayload });
    },

    handleShowToast: (callback: (msg: string, type: ToastType, hideDismissBtn: boolean, isImportant: boolean) => void) => {
      $rootScope.$on(ToastActionNames.SHOW_TOAST, (evt: any, {payload}: {payload: IToastActionPayload}) => {
        callback(payload.msg, payload.type, payload.hideDismissBtn, payload.isImportant);
      });
    },

    handleShowToastFullOptions: (callback: (props: IToastActionPayload) => void) => {
      $rootScope.$on(ToastActionNames.SHOW_TOAST_FULL_OPTIONS, (evt: any, {payload}: {payload: IToastActionPayload}) => {
        callback(payload);
      });
    },

    handleClearToast: (callback: () => void) => {
      $rootScope.$on(ToastActionNames.CLEAR_TOAST, (evt: any) => {
        callback();
      });
    }
  }
}


class ToastActionClean {

  clearToast(): void {
    store.dispatch(rootDisplayActions.clearToast())
  }

  showToast(message: string, type: ToastType, subText?: string, handleClose?: () => void): void {
    store.dispatch(rootDisplayActions.showToastClean({
      message,
      type,
      subText,
      handleClose
    }))
  }
}

const instanceClean = new ToastActionClean();

export { instanceClean as ToastActionClean };